import React, { useContext, useEffect, useState } from "react";
import Styles from "./OrderSummery.module.css";
import { ContextProvider } from "../../App";
import { useParams } from "react-router-dom";
import Footer from "../../common/Footer";
import AuthorizedHeader from "../../common/authorized/AuthorizedHeader";
import Header from "../../common/Header";
import Tables from "./Tables";

function OrderSummeryDetails() {
  const [orderDetails, setOrderDetails] = useState([]);
  const { id } = useParams();
  const { orderState, isMobile, authState } = useContext(ContextProvider);

  useEffect(() => {
    const oneOrderDetails = orderState.allOrders.filter(
      (order) => order._id === id
    );
    setOrderDetails(oneOrderDetails);
  }, []);
  return (
    <>
      <div>
        {authState.loggedIn === true ? <AuthorizedHeader /> : <Header />}
      </div>
      <div className={Styles.main_box}>
        {orderDetails.map((item) => {
          return <Tables key={item._id} item={item} />;
        })}
      </div>
      <Footer footerWidth={isMobile ? "100%" : "75%"} />
    </>
  );
}

export default OrderSummeryDetails;
